module.exports = __webpack_public_path__ + "static/media/computer_4.8683e84b.ico";